declare var swal: any;
import { Component, Input, OnInit } from '@angular/core';
import { ActorProfileSummaryRequest, ActorProfileSummaryInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { HCPService } from '../../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppData } from '../../../../models/appdata';
import { NgbProfilesummaryInfoModal } from './modals/profilesummary.modal';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';


@Component({
  selector: 'profilesummary',
  templateUrl: './profilesummary.component.html',
  styleUrls: ['./profilesummary.component.scss']
})

export class ProfileSummaryInfoComponent implements OnInit {

  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;

  @Input() CanShowRegistryView: number;

  public isRequesting: boolean = false;
  CurrentActorProfileSummaryRequest: ActorProfileSummaryRequest;
  CurrentActorProfileSummaryInfoController: ActorProfileSummaryInfoController;

  public ApiResData: ApiResponseModel;

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal) { }

  ngOnInit() {
    this.CurrentActorProfileSummaryRequest = new ActorProfileSummaryRequest();
    this.CurrentActorProfileSummaryInfoController = new ActorProfileSummaryInfoController();
    this.CurrentActorProfileSummaryRequest.ActorCode = this.ActorCode;
    this.CurrentActorProfileSummaryRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.CanShow === 1 || this.CanShowRegistryView === 1) {
      this.GetActorProfileSummaryInfoController();
    }

  }
  GetActorProfileSummaryInfoController() {

    this.StartRefreshing();
    this.hcpservice.GetActorProfileSummaryInfoController(this.CurrentActorProfileSummaryRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentActorProfileSummaryInfoController = this.ApiResData.Result[0];

         // console.log('this.CurrentActorProfileSummaryInfoController ' + this.CurrentActorProfileSummaryInfoController.DisplayName);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  OpenEditContent() {
    this.CurrentActorProfileSummaryRequest.ConditionalOperator = 2;
    this.CurrentActorProfileSummaryRequest.ActorCode = this.CurrentActorProfileSummaryInfoController.ActorCode;
    this.CurrentActorProfileSummaryRequest.ProfileSummary = this.CurrentActorProfileSummaryInfoController.ProfileSummary;

    const modalRef = this.modalService.open(NgbProfilesummaryInfoModal)//.result(result => { this.GetActorProfileController();});
    modalRef.componentInstance.CurrentActorProfileSummaryRequest = this.CurrentActorProfileSummaryRequest;
    modalRef.result.then(x => { this.GetActorProfileSummaryInfoController() })

  }



}
